
import { timeRangeOptions } from "@/utils/options";
import { shipmentBillOption } from "modules/logistics/shipment-bill/enum";

const dateTypeOption = [
    {id: 1, text: '预计出运日期'},
    {id: 2, text: '实际出运日期'},
    {id: 3, text: '预计签收日期'},
    {id: 4, text: '实际签收日期'},
    {id: 5, text: '创建时间'},
]

export default (transportOption) => [{
    prop: 'name',
    label: '视图名称',
    isFormItem: true,
    components() {
        return [{
            name: 'gj-input',
            prop: 'name',
            propsData: {
                placeholder: '请输入视图名称',
                style: {
                    width: '256px'
                }
            }
        }]
    },
    validator: [
        {required: true, message: '请输入视图名称', trigger: 'change'}
    ],
    labelWidth: '120px',
    defaultValue: ''
}, {
    label: '状态',
    prop: 'status',
    components: [{
        name: 'gj-select',
        prop: 'status',
        propsData: {
            placeholder: '状态',
            options: shipmentBillOption
        },
        style: {
            width: '150px'
        }
    }],
    isFormItem: true,
    labelWidth: '120px',
    defaultValue: ''
}, {
    label: '发货国',
    prop: 'shipCountryCode',
    components: [{
        name: 'gj-country-select',
        prop: 'shipCountryCode',
        propsData: {
            multiple: true
        },
        style: {
            width: '130px'
        }
    }],
    isFormItem: true,
    labelWidth: '120px',
    defaultValue: []
}, {
    label: '目的国',
    prop: 'arrivalCountryCode',
    components: [{
        name: 'gj-country-select',
        prop: 'arrivalCountryCode',
        propsData: {
            multiple: true
        },
        style: {
            width: '130px'
        }
    }],
    isFormItem: true,
    labelWidth: '120px',
    defaultValue: []
}, {
    label: '目的仓',
    prop: 'warehouseIds',
    components: [{
        name: 'gj-warehouse-select',
        prop: 'warehouseIds',
        propsData: {
            placeholder: '目的仓',
            multiple: true
        },
        style: {
            width: '150px'
        }
    }],
    isFormItem: true,
    labelWidth: '120px',
    defaultValue: []
}, {
    label: '物流方式',
    prop: 'transportId',
    components: [{
        name: 'gj-select',
        prop: 'transportId',
        propsData: {
            placeholder: '物流方式',
            options: transportOption
        },
        style: {
            width: '190px'
        }
    }],
    isFormItem: true,
    labelWidth: '120px',
    defaultValue: ''
}, {
    label: '店铺/国家',
    prop: 'marketIds',
    components: [{
        name: 'gj-market-select',
        prop: 'marketIds',
        propsData: {
            multiple: true
        }
    }],
    isFormItem: true,
    labelWidth: '120px',
    defaultValue: []
},  {
    label: '时间范围',
    prop: 'dateRange',
    isFormItem: true,
    labelWidth: '120px',
    components: [{
        name: 'gj-select',
        prop: 'dateType',
        propsData: {
            placeholder: '时间类型',
            options: dateTypeOption
        }
    }, {
        name: 'gj-select',
        prop: 'dateRange',
        propsData: {
            placeholder: '时间范围',
            options: timeRangeOptions,
            style: {
                marginLeft: '8px'
            }
        }
    }],
    validator: [
        {required: true, message: '请选择日期', trigger: 'change'}
    ]
}, {
    prop: 'dateType',
    defaultValue: 1
}]
